import { render, staticRenderFns } from "./MarketDetail.vue?vue&type=template&id=241fe9d2&"
import script from "./MarketDetail.vue?vue&type=script&lang=js&"
export * from "./MarketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports